import React, { useState } from "react";
import "./menu.less";
import { Icon_ChevronDown, Icon_ChevronUp, Icon_ChevronRight } from "../Icons/icons";
import { Popover } from "../Popover/Popover";

export interface SubMenuProps {
   itemKey: string | number;
   title?: React.ReactNode;
   children?: React.ReactNode | React.ReactNode[];
   mode?: "vertical" | "horizontal" | "inline";
   triggerSubMenuAction?: "hover" | "click";
   popupClassName?: string;
   selected: string | number | null;
   setSelected: (key: string | number | null) => void;
}

export const SubMenu: React.FC<SubMenuProps> = ({
   itemKey,
   title,
   children,
   mode,
   triggerSubMenuAction = "hover",
   popupClassName,
   selected,
   setSelected
}) => {
   const [openSubMenu, setOpenSubMenu] = useState<string | number | null>(null);

   const handleSubMenuClick = (key: SubMenuProps["itemKey"]) => {
      setOpenSubMenu(openSubMenu === key ? null : itemKey);
   };

   const renderSubMenu = (child: React.ReactNode) => {
      if (!React.isValidElement<SubMenuProps>(child)) return null;
      const childKey = child.key ? child.key : itemKey;
      return React.cloneElement(child, {
         ...child.props,
         mode,
         selected,
         setSelected,
         itemKey: childKey
      });
   };

   switch (mode) {
      case "inline":
         return (
            <li
               key={itemKey}
               className={`bp2-submenu-item${openSubMenu === itemKey ? "__expanded" : ""}`}
            >
               <div className="bp2-menu-item" onClick={() => handleSubMenuClick(itemKey)}>
                  {title}
                  {openSubMenu === itemKey ? (
                     <Icon_ChevronUp className="menu-chevron" fill="none" />
                  ) : (
                     <Icon_ChevronDown className="menu-chevron" fill="none" />
                  )}
               </div>
               <div className={`bp2-submenu-list${openSubMenu === itemKey ? "__expanded" : ""}`}>
                  <ul>
                     {Array.isArray(children)
                        ? children.map((item) => renderSubMenu(item))
                        : renderSubMenu(children)}
                  </ul>
               </div>
            </li>
         );
      case "vertical":
         return (
            <li key={itemKey} className={`bp2-submenu-item`}>
               <Popover
                  trigger={triggerSubMenuAction}
                  placement="right"
                  overlayClassName={`bp2-submenu-list__expanded vertical ${popupClassName}`}
                  content={
                     <ul className="bp2-menu-list">
                        {Array.isArray(children)
                           ? children.map((item) => renderSubMenu(item))
                           : renderSubMenu(children)}
                     </ul>
                  }
               >
                  <div className="bp2-menu-item" onClick={() => handleSubMenuClick(itemKey)}>
                     {title}
                     <Icon_ChevronRight className="menu-chevron" fill="none" />
                  </div>
               </Popover>
            </li>
         );
      case "horizontal":
         return (
            <li key={itemKey} className={`bp2-submenu-item`}>
               <Popover
                  trigger={triggerSubMenuAction}
                  placement="bottom"
                  overlayClassName={`bp2-submenu-list__expanded horizontal ${popupClassName}`}
                  content={
                     <ul className="bp2-menu-list">
                        {Array.isArray(children)
                           ? children.map((item) => renderSubMenu(item))
                           : renderSubMenu(children)}
                     </ul>
                  }
               >
                  <div className="bp2-menu-item" onClick={() => handleSubMenuClick(itemKey)}>
                     {title}
                     <Icon_ChevronDown className="menu-chevron" fill="none" />
                  </div>
               </Popover>
            </li>
         );
      default:
         return null;
   }
};
